module.exports = __webpack_public_path__ + "static/media/MCO1.806643e9.jpg";